import Home from '../components/Home';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import Product from '../components/Product';

const HomePage = () => {
    return (
        <div>
            <Home />
            <About />
            <Services />
            <Product />
            <Contact />
        </div>
    )
}

export default HomePage;